import { TBX_ENVS } from "../config";
import { THUMB_OR_POSTER, IMAGE_MODE } from "../constants/imageMode";

export const getContentImageByMode = (imagesArray, mode) => {
  mode = THUMB_OR_POSTER[mode]
  let image = null;
  if(!Array.isArray(imagesArray) || typeof mode !== 'string') return undefined;
  for (let i = 0; i < imagesArray.length; i++) {
    if (imagesArray[i].type === mode) { 
      image = imagesArray[i];
      break;
    }
  }
  return image;
};


export const getUrlUnityImageApi = (url) => {
  const TBX_UNITY_IMAGES_API = TBX_ENVS.TBX_UNITY_IMAGES_API
  if(!TBX_UNITY_IMAGES_API || typeof url !== 'string') return url;
  return url.replace('TBX_UNITY_IMAGES_API',TBX_UNITY_IMAGES_API)
};


/**
 * normalizeImageMode
 * @param {String} rowType
 * 
 * @return {String}
 */
export const normalizeImageMode = (rowType) => {
  switch(rowType) {
    case 'poster':
      return IMAGE_MODE.POSTER;
    case 'simple':
      return IMAGE_MODE.THUMB;
    case 'simpleLarge':
      return IMAGE_MODE.SIMPLE_LARGE;
    default:
      return IMAGE_MODE.THUMB;
  }
};

/**
 * get image setting from data
 * @param {Object} obj
 * @param {*} imageType
 * 
 * @return {Object}
 */
export const findImageSettingByType = (obj, imageType) => {
  const setting = obj?.find(element => element.name === imageType);
  if(typeof setting !== 'object') return {w:false,h:false}
  return setting;
};